import React, { Component } from 'react';

import CircularProgress from 'material-ui/CircularProgress';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4lang_es_ES from '@amcharts/amcharts4/lang/es_ES';

class MojaHoja extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false
		};
	};

	componentDidMount() {
		setTimeout(() => {
			this.loadChart();
		}, 16000);
	}

	loadChart = () => {
		this.setState({
			visible: true
		});

		const chart = am4core.create("mh", am4charts.XYChart);
		chart.zoomOutButton.disabled = true;
		chart.language.locale = am4lang_es_ES;

		chart.data = this.props.data;

		chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";

		const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
		dateAxis.groupData = false;
		dateAxis.renderer.grid.template.disabled = true;
		dateAxis.baseInterval = {
			"timeUnit": "hour",
			"count": 1
		};
		dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy";
		dateAxis.renderer.minGridDistance = 60;
		dateAxis.dateFormats.setKey("month", "MMM");
		dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
		dateAxis.dateFormats.setKey("day", "MMM dd");
		dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
		dateAxis.dateFormats.setKey("hour", "HH:mm");
		dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
		dateAxis.dateFormats.setKey("minute", "HH:mm");
		dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MMM dd[/]");
		dateAxis.keepSelection = true;
		dateAxis.start = 0.9;

		const buttonContainer = chart.plotContainer.createChild(am4core.Container);
		buttonContainer.shouldClone = false;
		buttonContainer.align = "right";
		buttonContainer.valign = "top";
		buttonContainer.zIndex = 100;
		buttonContainer.marginTop = 0;
		buttonContainer.marginRight = 5;
		buttonContainer.layout = "horizontal";

		const zoomInButton = buttonContainer.createChild(am4core.Button);
		zoomInButton.label.text = "+";
		zoomInButton.events.on("hit", function (ev) {
			const diff = dateAxis.maxZoomed - dateAxis.minZoomed;
			const delta = diff * 0.2;
			dateAxis.zoomToDates(new Date(dateAxis.minZoomed + delta), new Date(dateAxis.maxZoomed - delta));
		});

		const zoomOutButton = buttonContainer.createChild(am4core.Button);
		zoomOutButton.label.text = "-";
		zoomOutButton.events.on("hit", function (ev) {
			dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
		});

		const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis.title.disabled = true;
		valueAxis.extraMax = 0.1;
		valueAxis.max = 1;
		valueAxis.min = 0;
		valueAxis.renderer.minGridDistance = 60;

		function createSeries(field, name, color) {
			const series = chart.series.push(new am4charts.StepLineSeries());
			series.dataFields.valueY = field;
			series.dataFields.dateX = "fecha";
			series.name = name;
			series.strokeWidth = 3;
			series.minBulletDistance = 30;
			series.stroke = am4core.color(color);
			series.fill = am4core.color(color);
			series.showOnInit = false;
		}

		const serieActual = "Año Actual";

		createSeries("value", serieActual, "#8DCE3E");

		chart.cursor = new am4charts.XYCursor();
		chart.cursor.behavior = "zoomX";
		chart.cursor.xAxis = dateAxis;
		chart.cursor.fullWidthLineX = true;
		chart.cursor.lineX.strokeWidth = 0;
		chart.cursor.lineX.fill = am4core.color("#000");
		chart.cursor.lineX.fillOpacity = 0.1;
		chart.cursor.lineY.disabled = true;
		valueAxis.cursorTooltipEnabled = true;

		const info = chart.chartContainer.createChild(am4core.Container);
		info.layout = "absolute";
		info.toBack();
		info.marginBottom = 20;
		info.paddingLeft = 10;
		info.x = 0;
		info.y = 0;
		info.zIndex = 100;
		info.background.fill = am4core.color("#000");
		info.background.fillOpacity = 0;
		info.layout = "grid";

		function createLabel(title, color) {
			const valueLabel = info.createChild(am4core.Label);
			valueLabel.id = title;
			valueLabel.text = "-";
			valueLabel.minWidth = 220;
			valueLabel.fontWeight = "bolder";
			valueLabel.fill = color;
		}

		chart.series.each((series) => {
			createLabel(series.name, series.stroke);
		});

		chart.events.on("ready", () => {
			chart.series.each((series) => {
				updateValues(series.dataItems.last, series.name);
			});
		});

		chart.cursor.events.on("hidden", () => {
			chart.series.each((series) => {
				updateValues(series.dataItems.last, series.name);
			});
		});

		chart.cursor.events.on("cursorpositionchanged", () => {
			chart.series.each((series) => {
				const dataItem = dateAxis.getSeriesDataItem(
					series,
					dateAxis.toAxisPosition(chart.cursor.xPosition),
					true
				);
				updateValues(dataItem, series.name);
			});
		});

		function updateValues(dataItem, key) {
			chart.series.each(() => {
				if (!!dataItem) {
					const label = chart.map.getKey(key);
					const text = `MH: ${chart.numberFormatter.format(dataItem["valueY"])}`;

					label.text = text;
				}
			});
		}
	};

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	render() {
		if (this.state.visible) {
			return (
				<div id="mh" style={{ padding: '0' }} />
			);
		}

		return (
			<div style={{ position: 'relative', width: '100%', height: 'auto', padding: '10px', margin: 'auto auto' }}>
				<CircularProgress color={'#8DCE3E'} size={200} thickness={10} value={70} />
			</div>
		);
	}
}

export default MojaHoja;


// WEBPACK FOOTER //
// ./src/charts/MojaHoja.js